import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import s from './UserMenu.css';
import Link from '../../Link';

/** Первая буква email для аватара. */
function firstLetter(email) {
	if (typeof email === 'string' && email.length > 0) {
		return email.substr(0, 1).toUpperCase();
	}

	return 'A';
}

/**
 * Аватарка и меню пользователя.
 * В мобильной шапке (mobile) у гостя на её месте кнопка «Sign in»,
 * а у пользователя в меню добавляется «My themes».
 * @returns {*}
 * @constructor
 * @return {null}
 */
export default function UserMenu({ user, mobile }) {
	const [anchorEl, setAnchorEl] = React.useState(null);
	useStyles(s);

	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	if (!user) {
		return mobile ? (
			<Button
				className={s.signIn}
				href="/login/google"
				color="primary"
				variant="contained"
			>
				Sign in
			</Button>
		) : null;
	}

	const menuId = mobile ? 'user-menu-mobile' : 'user-menu';

	return (
		<span>
			<div className={mobile ? s.avatarMobile : s.avatarContainer}>
				<Avatar
					component="span"
					onClick={handleClick}
					aria-label="Profile"
					aria-controls={menuId}
					aria-haspopup="true"
				>
					{firstLetter(user.email)}
				</Avatar>
			</div>

			<Menu
				id={menuId}
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				{mobile && (
					<Link
						to="/themes/my"
						className={s.menuLink}
						onClick={handleClose}
					>
						<MenuItem>My themes</MenuItem>
					</Link>
				)}
				{user.role === 'admin' && (
					<Link
						to="/themes/all"
						className={s.menuLink}
						onClick={handleClose}
					>
						<MenuItem>All themes</MenuItem>
					</Link>
				)}
				{user.role === 'admin' && (
					<Link
						to="/admin/users"
						className={s.menuLink}
						onClick={handleClose}
					>
						<MenuItem>All users</MenuItem>
					</Link>
				)}
				<MenuItem
					onClick={() => {
						window.open('/logout', '_self');
					}}
				>
					Logout
				</MenuItem>
			</Menu>
		</span>
	);
}

UserMenu.propTypes = {
	user: PropTypes.shape({
		email: PropTypes.string,
		role: PropTypes.string,
	}),
	mobile: PropTypes.bool,
};

UserMenu.defaultProps = {
	user: null,
	mobile: false,
};
